module.exports = __webpack_public_path__ + "static/media/8-IMG_6701.5c162552.JPG";